<template>
  <div
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <h3 class="m-5 md:m-15 2xl:m-20">
      Compte rendu
    </h3>
    <!-- BEGIN button to add a new bilan -->
    <add-button
      class="mx-5 md:mx-15 2xl:mx-20"
      libelle="Ajouter un compte rendu"
      @add="addCR"
    />
    <!-- END button to add a new bilan -->

    <div v-if="form.rendus.length > 0">
      <list-grid
        :list-items="form.rendus"
        grid="grid-cols-12"
        :is-accordion-items="true"
        @displayNum="
          (num) => {
            crDisplayed = num;
          }
        "
        ref="listCRs"
      >
        <template #header>
          <div class="col-start-3 col-span-3 md:col-start-2 md:col-span-2">
            Date
          </div>
          <div class="col-span-7 md:col-span-5">
            Titre
          </div>
          <div class="hidden md:block md:col-span-3">
            Auteur
          </div>
        </template>

        <template #accordionDescription="{ item, num }">
          <icon
            class="text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300"
            :class="{ 'rotate-90': crDisplayed == num }"
            name="chevron-right"
          />

          <div class="col-span-3 md:col-span-2 text-base font-normal">
            <!-- Date -->
            <span v-if="item.date_saisie">
              {{ new Date(item.date_saisie).toLocaleDateString('fr') }}
            </span>
          </div>

          <div class="col-span-7 md:col-span-5 text-base font-normal">
            <!-- Titre -->
            {{ item.titre }}
          </div>

          <div class="hidden md:block md:col-span-3 text-base font-normal">
            <!-- Auteur -->
            {{ item.auteur }}
          </div>
        </template>

        <template #accordionContent="{ item, num }">
          <div class="grid grid-cols-12 gap-x-4 gap-y-10">
            <input-text
              name="titre"
              libelle="Titre"
              :necessary="true"
              :value="item.titre"
              @input="
                (newValue) => {
                  item.titre = newValue;
                }
              "
              class="md:col-span-4"
            />

            <date-picker
              name="date_saisie"
              :necessary-date="true"
              libelle="Date"
              class="col-span-full md:col-span-4"
              format="dd/MM/yyyy"
              initialview="year"
              :value="item.date_saisie"
              @input="
                (newValue) => {
                  item.date_saisie = newValue;
                }
              "
            />

            <!--            <input-text-area
              name="compte_rendu"
              :necessary="true"
              libelle="Compte rendu"
              size="5"
              :value="item.compte_rendu"
              @input="
                (newValue) => {
                  item.compte_rendu = newValue;
                }
              "
              class="col-start-1 col-span-full"
            />-->

            <tiptap
              name="compte_rendu_tiptap"
              :necessary="true"
              label="Compte Rendu"
              :value="item.compte_rendu"
              @update:value="(newValue) => { item.compte_rendu = newValue; }"
            />

            <!-- BEGIN button to delete current bilan -->
            <delete-button
              class="w-max"
              libelle="Supprimer ce compte rendu"
              @del="deleteItem(form.rendus, num)"
            />
            <!-- END button to delete current bilan -->
          </div>
        </template>
      </list-grid>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import DatePicker from '../../../components/Inputs/DatePicker';
import AddButton from '../../../components/Inputs/AddButton.vue';
import DeleteButton from '../../../components/Inputs/DeleteButton.vue';
import Icon from './../../../components/Icon.vue';
import Illustration from '../../../components/Illustration.vue';

import ListGrid from '../../../components/AccordionTable/ListGrid.vue';
import Tiptap from '../../../components/Inputs/Tiptap.vue';

export default {
  components: {
    Tiptap,
    ListGrid,
    InputText,
    InputTextArea,
    DatePicker,
    AddButton,
    DeleteButton,
    Icon,
    Illustration,
  },

  props: ['progressbar'],

  name: 'CompteRendu',

  data() {
    return {
      crDisplayed: -1,

      form: {
        rendus: [],
      },
    };
  },

  mounted() {
    this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)
    this.calculate_progress();
    this.sortRendus(false);
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
    this.applyFormWatcher();
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
    }),

    applyFormWatcher() {
      this.$watch(
        'form',
        function () {
          this.infosPage.isFormChanged = true;
        },
        { deep: true }
      );
    },

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);

      this.sortRendus(false);
    },

    async addCR() {
      await this.form.rendus.unshift({
        titre: '',
        auteur: this.user.firstname + ' ' + this.user.lastname,
        compte_rendu: '',
        date_saisie: new Date(),
      });

      await this.$refs.listCRs.displayNum(0, true);
    },

    deleteItem(el, index) {
      el.splice(index, 1);
    },

    sortRendus(sorting = true) {
      let rendusDisplayed = this.form.rendus[this.crDisplayed];
      this.form.rendus.sort(function (b1, b2) {
        let date1 = new Date(b1.date_saisie);
        let date2 = new Date(b2.date_saisie);

        if (date1 < date2) {
          return 1;
        } else if (date1 > date2) {
          return -1;
        } else {
          return 0;
        }
      });

      if (sorting) {
        this.$refs.listCRs.displayNum(
          this.form.rendus.indexOf(rendusDisplayed),
          true
        );
      }
    },
  },

  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      user: 'auth/user',
    }),
  },
};
</script>
